import s from './style.module.scss';
import GrtImage from '@/components/GrtImage';
import { Display } from '@/components/Display/Display';
import { useEffect, useState } from 'react';
import { insertModal, removeModal } from '@/utils/Page/modal';
// import CourseDetail from '../Modals/CourseDetail';
import { handleClickLearn } from '@/utils/Page/courseRecommend';
import { handleGetcourseDetail } from '@/api/grt/courseCommend';
import CourseDetail from './CourseDetail';
import ChoseCourse from './ChoseCourse';
import { Modal } from 'antd';
import ToastUtils from '@/utils/ToastUtils';
const WebCourseRecommend = (props) => {
    console.log(props, 'props');

    let { data = [], loading = false, description = '' } = props.recommend_course_result;

    const clickLearn = async (id) => {
        let list = await handleClickLearn(id);
        //多项目选择
        if (list) {
            window.choseCourseModal = Modal.info({
                title: '选择视频',
                width: 560,
                maskClosable: false,
                closable: true,
                icon: null,
                keyboard: false,
                content: <ChoseCourse list={list} resource_id={id}></ChoseCourse>,
                footer: null
            });
        }
    };
    const viewDetail = async (data) => {
        let res = await handleGetcourseDetail({ resource_id: data?.id });
        if (res && res.success && res.data) {
            res.data.resource_id = data?.id;
            res.data.resource_name = data?.title;
            insertModal(<CourseDetail detail={res?.data} clickLearn={clickLearn} onClose={removeModal}></CourseDetail>);
        } else {
            ToastUtils.showAbnormalToast(res?.msg || '操作失败');
        }
    };

    return (
        <>
            <div className={s['box-wrap']}>
                <Display show={!loading}>
                    <>
                        <div className={s['title']} style={{ fontWeight: 'normal' }}>
                            {description}
                        </div>
                        <div className={s['list-wrap']}>
                            {data.map((ele, index) => {
                                return (
                                    <div key={index} className={s['list-item']}>
                                        <GrtImage src={ele?.image_url}></GrtImage>
                                        <div className={s['course-title']}>{ele.title}</div>
                                        <div className={s['list-action']}>
                                            <span
                                                className={s['action-button']}
                                                onClick={() => {
                                                    viewDetail(ele);
                                                }}
                                            >
                                                查看详情
                                            </span>
                                            <span
                                                onClick={() => {
                                                    clickLearn(ele.id);
                                                }}
                                                className={s['action-button']}
                                            >
                                                立即学习
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                </Display>

                <Display show={loading}>
                    <>
                        <div className={[`${s['title']} loading-text`]} data-text="正在搜索相关课程">
                            正在搜索相关课程
                        </div>
                        <div className={s['list-wrap']}>
                            {[1, 2, 3].map((ele, index) => {
                                return (
                                    <div key={index} className={`${s['list-item']} loading-item`}>
                                        <div className={s['img-wrap']}></div>
                                        <div className={s['course-title']}>{ele.title}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                </Display>
            </div>
        </>
    );
};

export default WebCourseRecommend;
